import { render } from "./PendingApprovalMedical.vue?vue&type=template&id=672c3e46"
import script from "./PendingApprovalMedical.vue?vue&type=script&lang=js"
export * from "./PendingApprovalMedical.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__